import {
  AfterViewInit,
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  Pipe,
  PipeTransform,
} from '@angular/core';
import {FormControl} from '@angular/forms';
import {DropDownElement} from '../../../drop-down-element';
import {UploadFile} from '../../../upload-file';

@Component({
  selector: 'app-metadata-list',
  templateUrl: './metadata-list.component.html',
  styleUrls: ['./metadata-list.component.css']
})
export class MetadataListComponent implements OnInit, AfterViewInit {
  @Input()
  infoFields: any;
  @Input()
  valueOptions: any[];
  @Input()
  selectizeConfigs: any;
  @Input()
  uploadedFile: UploadFile;
  @Output()
  uploadedFileChange = new EventEmitter<UploadFile>();
  language = 'en';
  @Input()
  metadataLanguages;
  @Input()
  defaultLanguage;
  @Input()
  urlPresetsMap;
  @Input()
  hideDisabledFields;
  @Input()
  sameMetadataEveryAsset;
  @Output()
  appliedInfofield = new EventEmitter<any>();
  @Input()
  dateFormat: string;

  ngOnInit() {
    this.initializeFormControls();
    if (this.uploadedFile.configuration && this.uploadedFile.configuration.language) {
      this.language = this.uploadedFile.configuration.language;
    }
  }

  ngAfterViewInit(): void {
    this.initializeFormControls();
  }


  private initializeFormControls() {
    if (this.uploadedFile.configuration) {
      this.uploadedFile.valueControls = new Array(this.uploadedFile.configuration.informationFields.length);
      if (this.uploadedFile.configuration.assetType != null) {
        this.uploadedFile.configuration.informationFields.forEach((infoField, i) => {
          if (!infoField.defaultValue) {
            if (this.urlPresetsMap[infoField.informationfieldId]) {
              infoField.defaultValue = this.urlPresetsMap[infoField.informationfieldId];
            }
          }
          let defaultValueFormControl = new FormControl();
          if (infoField.kind === 'DROP_DOWN' || infoField.kind === 'NODE_REFERENCE') {
            if (infoField.kind === 'DROP_DOWN') {
              this.uploadedFile.valueControls[i] = new FormControl();
              this.valueOptions[i].forEach(defaultValueOption => {
                const defaultValueOptionOption = defaultValueOption as DropDownElement;
                if (infoField.defaultValue === defaultValueOptionOption.key) {
                  defaultValueFormControl = new FormControl(defaultValueOption);
                  this.uploadedFile.valueControls[i] = defaultValueFormControl;
                } else if (this.urlPresetsMap[infoField.informationfieldId] &&
                  this.urlPresetsMap[infoField.informationfieldId] === defaultValueOptionOption.key) {
                  defaultValueFormControl = new FormControl(defaultValueOption);
                  this.uploadedFile.valueControls[i] = defaultValueFormControl;
                }
                if (infoField.locked) {
                  this.uploadedFile.valueControls[i].disable();
                }
              });
            } else if (infoField.kind === 'NODE_REFERENCE') {
              this.uploadedFile.valueControls[i] = defaultValueFormControl;
              this.uploadedFile.valueControls[i].setValue(infoField.defaultValue);
              if (infoField.locked) {
                this.uploadedFile.valueControls[i].disable();
              }
            }
          } else if (infoField.kind === 'LOCALIZED_TEXT' || infoField.kind === 'LOCALIZED_TEXT_AREA') {
            if (!infoField.defaultValue) {
              infoField.defaultValue = {};
              infoField.defaultValue['values'] = [];
              this.metadataLanguages.forEach(infofieldLanguage => {
                infoField.defaultValue['values'][infofieldLanguage] = '';
              });
            }
            this.uploadedFile.valueControls[i] = [];
            this.metadataLanguages.forEach(infofieldLanguage => {
              if (!this.uploadedFile.valueControls[i][infofieldLanguage]) {
                this.uploadedFile.valueControls[i][infofieldLanguage] = new FormControl();
                if (infoField.defaultValue && infoField.defaultValue['values'] && infoField.defaultValue['values'][infofieldLanguage]) {
                  this.uploadedFile.valueControls[i][infofieldLanguage].setValue(infoField.defaultValue['values'][infofieldLanguage]);
                }
                if (infoField.locked) {
                  this.uploadedFile.valueControls[i][infofieldLanguage].disable();
                }
              }
            });
          } else if (infoField.kind === 'TEXT' || infoField.kind === 'DOUBLE' ||
            infoField.kind === 'NUMBER' || infoField.kind === 'TEXT_AREA' || infoField.kind === 'BOOLEAN') {
            if (!this.uploadedFile.valueControls[i]) {
              this.uploadedFile.valueControls[i] = new FormControl();
            }
            this.uploadedFile.valueControls[i].setValue(infoField.defaultValue);
            if (infoField.locked) {
              this.uploadedFile.valueControls[i].disable();
            }
          } else {
            if (infoField.kind === 'DATE') {
              if (infoField.defaultValue != null) {
                defaultValueFormControl.setValue(new Date(Number(infoField.defaultValue)));
              }
            }
            this.uploadedFile.valueControls[i] = defaultValueFormControl;
            if (infoField.locked) {
              this.uploadedFile.valueControls[i].disable();
            }
          }
        });
      }
    }
  }

  getOptionDisplayText(option) {
    return option && option.displayText ? option.displayText : '';
  }

  applyInfofield(event, valueControl, index) {
    this.appliedInfofield.emit({formControl: valueControl, index});
    if (event) {
      event.stopPropagation();
    }
  }

  public applyAllInfofields() {
    for (let i = 0; i < this.uploadedFile.valueControls.length; i++) {
      if (this.uploadedFile.valueControls[i]) {
        this.applyInfofield(null, this.uploadedFile.valueControls[i], i);
      }
    }
  }

  defocus() {
    (document.activeElement as HTMLElement).blur();
    (document.activeElement as HTMLElement).blur();
  }


}

@Pipe({name: 'brToNArray'})
export class BRtoNPipe implements PipeTransform {
  transform(value: string): string {
    const regex = /<br\s*[\/]?>/gi;
    if (value) {
      return value.replace(regex, '\n');
    }
    return value;
  }


}
